import { contactGroupGetters } from "./groups/getters";
import { contactFileGetters } from "./files/getters";

export const getters = {
  contactsData: (state) => state.contactsData,
  // contactListStartRow: (state) => state.contactListStartRow,
  selectedContact: (state) => state.selectedContact,
  selectedContactLoading: (state) => state.selectedContactLoading,
  // contactDetailsGrid: (state) => state.contactDetailsGrid,
  accountingInfo: (state) => state.accountingInfo,
  
  searchConfig: (state) => state.searchConfig,
  contactDetails: (state) => state.contactDetails,


  ...contactGroupGetters,
  ...contactFileGetters,
}